<template>
  <div v-if="can('update', 'payroll_info')">
    <b v-if="employeeState=='showing'"><p class="text-danger" v-if="edited">Los cambios no han sido guardados. <a href="#" @click.prevent="saveChanges">Guardar.</a></p></b>
    <b-button class="float-right" @click="resetNewLoans" v-if="edited == true" >Descartar cambios</b-button>
    <b-table responsive v-if="loans.length>0" :fields="loanFields" :items="loans" hover striped></b-table>
    <b-button variant="success" v-if="state=='show'" @click="create">Agregar préstamo</b-button>
    <div v-if="state=='creating'">
      <b-form-group horizontal label="Concepto">
        <b-form-input type="text" @input="updateLoan(['reason', $event])" :value="reason"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Fecha que fue solicitado">
        <b-form-input type="date" @input="updateLoan(['requested_date', $event])" :value="requested_date"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Cantidad a prestar">
        <b-form-input type="number" @input="updateLoan(['amount', $event])" :value="amount"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Interés">  
        <b-form-input type="number" @input="updateLoan(['interest', $event])" :value="interest"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Semanas a pagar">  
        <b-form-input type="number" @input="updateLoan(['periods', $event])" :value="periods"></b-form-input>
      </b-form-group>
      <b-button variant="success" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Validation } from '../../utils';
export default{
  data (){
    return {
      loanFields: {
        reason: {
          label: 'Concepto',
        },
        requested_date: {
          label: 'Solicitado el',
          sortable: true
        },
        amount: {
          label: 'Prestado',
          sortable: true
        },
        periods: {
          label: 'Semanas'
        },
        interest: {
          label: 'Interés'
        },
        amount_with_interest: {
          label: 'Prestado con interés'
        },
        payed: {
          label: 'Pagado',
          sortable: true
        },
        default_payment: {
          label: 'Pago por defecto',
          sortable: true
        }
      }
    }
  },
  methods: {
    can: (action, resource)=>{
      if(permissions===null) return false
      if(typeof(permissions[resource])==='undefined') return false
      return permissions[resource].includes(action)
    },

    ...mapActions(['resetNewLoans', 'saveChanges']),
    ...mapMutations({
      updateLoan: 'updateNewLoanAttribute',
      create: 'creatingLoan'
    }),
    addIfValid (){
      var validation = this.valid()
      if(validation.valid)
        this.$store.dispatch('addLoan');
      else
        this.$store.dispatch('displayError',validation.messageBag);
    },
    valid (){
      var validator = new Validation();
      validator.rule(
        this.reason!='', 'El concepto no puede estar vacío')
      validator.rule(
        this.requested_date!='', 'Debe haber una fecha para comenzar a pagar')
      validator.rule(
        this.amount>0, 'El préstamo debe ser mayor a 0')
      validator.rule(
        this.interest>0, 'El interés debe ser mayor a cero')
      validator.rule(
        this.periods>0, 'El número de semanas a pagar debe ser mayor a cero')
      
      
      return validator.validate()
    }
  },
  computed: {
    ...mapGetters({
      edited: 'loanEdited'
    }),
    ...mapState({
      employeeState: state=>state.employeeManager.state,
      loans: state=>state.employeeManager.employee.loans,
      state: state=>state.employeeManager.loanState,
      amount: state=>state.employeeManager.newLoan.amount,
      interest: state=>state.employeeManager.newLoan.interest,
      reason: state=>state.employeeManager.newLoan.reason,
      periods: state=>state.employeeManager.newLoan.periods,
      requested_date: state=>state.employeeManager.newLoan.requested_date,
      })
  }
  
}
</script>
